export enum ShopifyPlan {
  NONE = "none",
  STANDARD = "standard",
  PLUS = "plus",
}
